import Vue from 'vue'
import Router from 'vue-router'
import PCIndex from './views/PC/index.vue'
import PCFullScreenIndex from './views/PC/fullScreenIndex.vue'
import MobIndex from './views/Mobile/index.vue'
import Evaluate from './views/Mobile/evaluate.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      components: {
        default: PCIndex,
        MobIndex: MobIndex,
        PCFullScreenIndex: PCFullScreenIndex,
        Evaluate:Evaluate
      }
    }
  ]
})
